export const DISCLOSURE_ACCOUNTING = 66;
export const DISCLOSURE_EVENT = 43;
export const DISABILITY_OR_SOCIAL_SECURITY = 31;
export const AUDIT = 53;
export const INTERNAL = 21;

export interface RequestPurpose {
    id: number,
    name: string,
    /**
     * @deprecated Not set by the API in all cases. Use `RequestType`.
     */
    typeID: number,
    /**
     * @deprecated Not set by the API in all cases. Use `RequestType`.
     */
    typeName: string,
}

export interface RequestType {
    id: number,
    name: string,
    requestPurpose: RequestPurpose[],
}

export interface RequestPurposeUpdate {
    organizationId: number,
    requestBufferId: number,
    requestPurposeId: number,
    clearFeeOk: boolean,
}
